<template>
  <div class="table-wrapper">
    <div ref="subTable" class="sub-table">
      <div v-for="(theTotal, i) in allTotals" v-bind:key="i" class="a-row">
        <div class="table-cell-1">
          {{ theTotal.label }}{{ theTotal.annotation }}
        </div>
        <div
          class="table-cell-2"
          :title="theTotal.label"
          style="max-width: 100px"
        >
          {{ common.formatNumber(theTotal.total, 0) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from "@/scripts/common";
import commonModelHelper from "@/scripts/commonModelHelper";
import current from "@/scripts/current";
import store from "@/store";

export default {
  props: ["recordTotals", "selectedStatistics"],
  mounted: function () {
    const vm = this;
    //We are only setting width
    store.dispatch("loadedControls/mounted", {
      name: "datasetTotals",
      control1: vm.control1,
      control2: vm.control2,
      vm,
      subTable: vm.$refs.subTable,
    });
  },
  data: function () {
    var vm = this;
    var allTotals = commonModelHelper.getDatasetTotalRecords(vm.recordTotals);
    return {
      modelHelper: current.modelHelper,
      common: common,
      allTotals: allTotals,
    };
  },
  methods: {},
};
</script>

<style scoped>
.wrapper {
  display: inline-block;
}

div {
  font-size: 14px;
}
td {
  padding: 0px 8px 0px 8px;
  white-space: nowrap;
}

.table-wrapper {
  width: 100%;
  overflow: auto;
}

.sub-table {
  width: fit-content;
}
/* .sub-table {
  col-xs-12 col-sm-12 col-md-12 col-lg-10
} */

.a-row {
  overflow: auto;
  width: fit-content;
}
.table-cell-1 {
  float: left;
  /* overflow: auto; */
  /* <div class="col-xs-9 col-sm-8 col-lg-10" style="max-width: 500px"> */
}
.table-cell-2 {
  float: left;
  /* overflow: auto; */
  /* /col-xs-3 col-sm-2 col-lg-2 style="max-width: 100px" */
}

@media (max-width: 575px) {
  .table-cell-1 {
    width: 100%;
  }
  .table-cell-2 {
    width: 100%;
  }
  .a-row {
    width: 100%;
  }
}

@media (min-width: 576px) {
  .table-cell-1 {
    width: 75%;
  }
  Z .table-cell-2 {
    width: 25%;
  }
  .a-row {
    width: 100%;
  }
}

@media (min-width: 768px) {
  .table-cell-1 {
    width: 500px;
  }
  .table-cell-2 {
    width: 100px;
  }
}
/* 
@media (min-width: 992px) {
}
@media (min-width: 1200px) {
} */
</style>
